import { ArrowBack } from "@mui/icons-material";
export default function GoBack({onClick,...props}) {

    return (
        <ArrowBack onClick={onClick} sx={{position:"absolute","&:hover":{cursor:"pointer"}}} {...props} />
    );
}